import { runInAction } from 'mobx';
import langstore from 'System/i18n/translator.js';

export const pushPreferencesLoad = async function ({ silent = false, skipGuard = false } = {}) {
    if (!skipGuard && !this.pushNotificationSubscribed) return null;

    runInAction(() => { this.pushPreferencesLoading = true; });

    try {
        const res = await this.dataLayer({
            url: this.config.paths.apiURL + 'push/preferences',
            cacheAge: null,
            params: {},
            userToken: this.userToken,
        });

        // Auth failure or network error: dataLayer returns undefined.
        // Return null (indeterminate) so callers do NOT treat this as an orphan subscription.
        if (!res) return null;

        // Backend explicitly rejected the request (subscription unknown to backend = orphan).
        if (res.status !== 'OK') return false;

        const preferences = res.data?.preferences || [];

        runInAction(() => {
            this.pushPreferences = preferences;
            // Endpoint attivi dell'utente sul BE: servono a pushNotificationInit per la
            // riconciliazione (rinnovo silenzioso se l'endpoint locale non è più tra questi).
            this.pushActiveEndpoints = Array.isArray(res.data?.endpoints) ? res.data.endpoints : null;
        });

        return true;
    } catch (_) {
        if (!silent) {
            this.notificationAdd(
                langstore.t('push_preferences_load_error', 'Errore durante il caricamento delle preferenze notifiche'),
                'push_preferences_load_error',
                null,
                'error'
            );
        }
        // Unexpected error: return null (indeterminate), not false (orphan signal).
        return null;
    } finally {
        runInAction(() => { this.pushPreferencesLoading = false; });
    }
};

export const pushPreferencesSave = async function (changed) {
    runInAction(() => { this.pushPreferencesLoading = true; });

    try {
        const res = await this.dataLayer({
            url: this.config.paths.apiURL + 'push/preferences/save',
            cacheAge: null,
            params: {
                preferences: changed,
            },
            userToken: this.userToken,
        });

        if (res.status !== 'OK') throw new Error(res.message || 'error');

        this.notificationAdd(
            langstore.t('push_preferences_saved', 'Preferenze notifiche salvate'),
            'push_preferences_saved'
        );

        await this.pushPreferencesLoad();
    } catch (_) {
        this.notificationAdd(
            langstore.t('push_preferences_save_error', 'Errore durante il salvataggio delle preferenze notifiche'),
            'push_preferences_save_error',
            null,
            'error'
        );
        runInAction(() => { this.pushPreferencesLoading = false; });
    }
};
